import {FornecedorModel} from '@/models/gestao/fornecedor/fornecedor.model';
import api from '@/services/axios/api';
import {AxiosResponse} from 'axios';
import {DataSource, FiltrosModel} from '@/datasources/consulte-grid';
import TextoValor from '@/models/texto-valor';
import {RegisterOutput} from '@/models/register-output';
import { GesFornecedorModel } from '@/models/gestao/ges-fornecedor.model';
import router from '@/routes';



class FornecedorService 
{
 dadosIndexPaginadoPorTipoFornecedor(
  pagina: number,
  itensPorPagina: number,
  filters: FiltrosModel[],
  tipoFornecedor: number
 ): Promise<AxiosResponse<DataSource<GesFornecedorModel>>> {
  return api.post<DataSource<GesFornecedorModel>>(
   '/Fornecedor/RetornoPaginado',
   {
    rowsPerPage: itensPorPagina,
    pageNumber: pagina,
    filters: filters
   },
   {
    params: {
     tipoFornecedor: tipoFornecedor,
    },
   }
  );
 }

 dadosIndexPaginado(
    pagina: number,
    itensPorPagina: number,
    filters: FiltrosModel[]
  ): Promise<AxiosResponse<DataSource<GesFornecedorModel>>> {
    const routePath = router.currentRoute.value.path;
    const lsItens = routePath.split('/').filter(Boolean);

    const tipoFornecimento = Number(lsItens[lsItens.length - 1]);

    return this.dadosIndexPaginadoPorTipoFornecedor(pagina, itensPorPagina, filters, tipoFornecimento);
  }

 inserirAtualizar(fornecedor: FornecedorModel): Promise<AxiosResponse<RegisterOutput>> {
  const result = api.post('/Fornecedor', fornecedor);
  return result;
 }

 remover(id: number): Promise<AxiosResponse> {
  return api.delete('/Fornecedor/' + id);
 }

 atualizar(fornecedor: FornecedorModel): Promise<AxiosResponse> {
  return api.put('/Fornecedor', fornecedor);
 }

 async get(id: number): Promise<FornecedorModel> {
  const result = await api.get<FornecedorModel>(`/Fornecedor/${id.toString()}`);
  return result.data;
 }

 async DropDownList(tipoFornecedor?: number | null) : Promise<TextoValor[]> {
  const endpoint = "/Fornecedor/DropDownList";
  const result = await api.get(endpoint, {
   params: tipoFornecedor !== undefined && tipoFornecedor !== null
    ? { tipoFornecedor, tipofornecedor: tipoFornecedor }
    : undefined
  });
  // Mapeando os dados para o formato TextoValor
  return result.data.map((item: any) => ({
   valor: item.valor,
   texto: item.texto,
   }));
 }
}
export default new FornecedorService();
